import styled from 'styled-components';
import { formatCurrency } from 'utils';
import { Vehicle } from 'types/vehicle';
import { Divider } from '@material-ui/core';
import { SectionDivider } from 'pages/Shared/VehicleDetails/components';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OfferInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const YourOfferInfo = styled.div`
  color: #212121;
  line-height: 100%;
  font-size: 16px;
  text-align: center;

  span {
    font-weight: 600;
  }
`;

export const AlternativeOfferInfoSection = ({ vehicle }: { vehicle: Vehicle }) => {
  const myOffer = vehicle.my_alternative_bid_offer?.amount;

  if (!myOffer) return null;

  return (
    <>
      <SectionDivider />
      <Wrapper>
        <OfferInfoWrapper>
          <YourOfferInfo>
            {`Your max offer - `}
            <span>{formatCurrency(myOffer)}</span>
          </YourOfferInfo>
        </OfferInfoWrapper>
      </Wrapper>
    </>
  );
};
